import React from 'react'
import PropTypes from 'prop-types'
import { TbTimezone } from 'react-icons/tb'

// Components
import { CalendarIcon } from '../CalendarIcon'
import { LocationIconSolid } from '../LocationIconSolid'
import { TicketSimpleIcon } from '../TicketSimpleIcon'

/**
 *
 * EventHeader
 */
const EventHeader = ({ event }) =>
  event ? (
    <div className="pb-4">
      <div className="flex flex-row place-items-center space-x-2">
        <TicketSimpleIcon className="h-4 fill-darkBlue-dark stroke-darkBlue-dark lg:h-6" />
        <span className="text-lg font-semibold text-gray-dark lg:text-2xl">{event.name}</span>
      </div>

      <div className="flex flex-row space-x-4 text-xs font-medium text-gray-500 lg:text-sm">
        <div className="flex flex-row place-items-center space-x-2">
          <LocationIconSolid className="fill-gray-500" />
          <span>{event.location || 'N/A'}</span>
        </div>

        {event.timezone && (
          <div className="flex flex-row place-items-center space-x-2">
            <TbTimezone size={22} />
            <span>{event.timezone}</span>
          </div>
        )}

        <div className="flex flex-row place-items-center space-x-2">
          <CalendarIcon className="fill-gray-500" />
          <span>{event.dateRange || 'N/A'}</span>
        </div>
      </div>
    </div>
  ) : null

EventHeader.propTypes = {
  event: PropTypes.object.isRequired,
}

export default EventHeader
